"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.useGiftingFlowContext = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _query = require("@reduxjs/toolkit/query");

var _services = require("@alycecom/services");

var _hooks = require("../hooks");

var _giftingFlow = require("../helpers/giftingFlow.helpers");

var giftingFlowContextDefaultValue = {
  campaignId: undefined,
  batchId: undefined,
  vidyardClientId: undefined,
  setCampaignId: function setCampaignId() {},
  setBatchId: function setBatchId() {},
  onBatchCreated: function onBatchCreated() {},
  onBatchSent: function onBatchSent() {}
};
var GiftingFlowContext = /*#__PURE__*/(0, _react.createContext)(giftingFlowContextDefaultValue);

var useGiftingFlowContext = function useGiftingFlowContext() {
  return (0, _react.useContext)(GiftingFlowContext);
};

exports.useGiftingFlowContext = useGiftingFlowContext;

var GiftingFlowProvider = function GiftingFlowProvider(_ref) {
  var initialCampaignId = _ref.campaignId,
      initialBatchId = _ref.batchId,
      vidyardClientId = _ref.vidyardClientId,
      children = _ref.children,
      onBatchCreated = _ref.onBatchCreated,
      _ref$onBatchSent = _ref.onBatchSent,
      onBatchSent = _ref$onBatchSent === void 0 ? function () {} : _ref$onBatchSent;

  var _useGiftingFlowSteps = (0, _hooks.useGiftingFlowSteps)(),
      setActiveStep = _useGiftingFlowSteps.setActiveStep,
      useActiveStep = _useGiftingFlowSteps.useActiveStep;

  var activeStep = useActiveStep();

  var _useState = (0, _react.useState)(initialCampaignId ? Number(initialCampaignId) : initialCampaignId),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      campaignId = _useState2[0],
      setCampaignId = _useState2[1];

  var handleSetCampaignId = (0, _react.useCallback)(function (id) {
    return setCampaignId(id);
  }, []);

  var _useState3 = (0, _react.useState)(initialBatchId ? Number(initialBatchId) : initialBatchId),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      batchId = _useState4[0],
      setBatchId = _useState4[1];

  var handleSetBatchId = (0, _react.useCallback)(function (id) {
    return setBatchId(id);
  }, []);

  var _useGetProspectingBat = (0, _services.useGetProspectingBatchByIdQuery)(batchId ? {
    batchId: Number(batchId)
  } : _query.skipToken),
      batch = _useGetProspectingBat.data,
      isFulfilled = _useGetProspectingBat.isSuccess;

  var calculatedStep = (0, _giftingFlow.getBatchLastStep)({
    batch
  });
  var batchCampaignId = batch === null || batch === void 0 ? void 0 : batch.campaignId;
  (0, _react.useEffect)(function () {
    if (batchCampaignId) {
      setCampaignId(batchCampaignId);
    }
  }, [batchCampaignId]);
  (0, _react.useEffect)(function () {
    setCampaignId(initialCampaignId ? Number(initialCampaignId) : initialCampaignId);
  }, [initialCampaignId]);
  (0, _react.useEffect)(function () {
    setBatchId(initialBatchId ? Number(initialBatchId) : initialBatchId);
  }, [initialBatchId]);
  var isCalculatedStepReady = !activeStep && (batchId && isFulfilled || !batchId);
  (0, _react.useEffect)(function () {
    if (isCalculatedStepReady) {
      setActiveStep(calculatedStep);
    }
  }, [isCalculatedStepReady, calculatedStep, setActiveStep]);
  var value = (0, _react.useMemo)(function () {
    return {
      campaignId,
      batchId,
      vidyardClientId,
      setCampaignId: handleSetCampaignId,
      setBatchId: handleSetBatchId,
      onBatchCreated,
      onBatchSent
    };
  }, [campaignId, batchId, handleSetCampaignId, handleSetBatchId, vidyardClientId, onBatchCreated, onBatchSent]);
  return /*#__PURE__*/_react.default.createElement(GiftingFlowContext.Provider, {
    value: value
  }, children);
};

var _default = GiftingFlowProvider;
exports.default = _default;